const ENTER_TRANSITION_DURATION_MS = 200;
const transitionCls = "_275tyf5pz0";

export { ENTER_TRANSITION_DURATION_MS, transitionCls };
import "./page.styles.linaria.module.css";
//# sourceMappingURL=page.styles.js.map
